<div class="row">
    <div class="form-group col-md-6 col-lg-6 col-sm-12 col-xs-12 ngb-dp-arrow-abbonamenti">

        <div class="form-group">
            <label for="idCategoria" style="color: #fff !important">Fascia Oraria:</label>
            <select (change)="globalData.onFasciaOrariaChangeAbbonamenti()" #fasciaOraria
                [(ngModel)]="globalData.fasciaOrariaSelezionata" class="form-control">
                <option value='1'>Intera Giornata</option>
                <option value='2'>Mattina</option>
                <option value='3'>Pomeriggio</option>

            </select>
        </div>
        <ngb-datepicker #dp (dateSelect)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="t"
            outsideDays="hidden" />


        <ng-template #t let-date let-focused="focused">
            <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                (mouseleave)="hoveredDate = null">
                {{ date.day }}
            </span>
        </ng-template>

    </div>
    <div class="form-group col-md-6 col-lg-6 col-sm-12 col-xs-12 ">
        <a style="width: 100%; z-index: 999; cursor: pointer;" (click)="scegliPeriodo(fromDate, toDate)"
            class="btn btn-primary">Scegli il periodo</a>
    </div>

</div>